import isObject from 'lodash-es/isObject';

/**
 * Hook for conditionally resolving the provided bleed values based on the options.
 *
 * @param options - Options for applying the bleed.
 * @param values - The values to apply the bleed to.
 */ function useBleed(options, { x, y }) {
    const shouldBleedX = isObject(options) ? options.x : options;
    const shouldBleedY = isObject(options) ? options.y : options;
    return [
        shouldBleedX && x ? x : null,
        shouldBleedY && y ? y : null
    ];
}

export { useBleed };
//# sourceMappingURL=use-bleed.js.map
